import { updateField } from 'vuex-map-fields'

const SET_REPORTS = (state, payload) => {
  state.reports = payload
}

export default {
  updateField,
  SET_REPORTS
}
